import { HeartIcon } from 'lucide-react';

export function AppHeartIcon({filled = false}: {filled?: boolean}) {
  return filled ? <HeartIcon fill="#c6005c" className="text-pink-700" /> : <HeartIcon />;
}
